import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import PageLoading from 'modules/layout/components/Page/Loading'
import { useBulkImportSupplements } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import supplementBulkImportCollection from 'modules/payroll_bundle/store/collections/supplementBulkImports'

import SupplementsList from './SupplementsList'

const ManageImportedModal = () => {
  const { currentPolicyPeriods, periodIndex } = usePolicyPeriods()
  const currentPolicyPeriod = currentPolicyPeriods[periodIndex]
  const { supplementDispatch } = useBulkImportSupplements()

  const { loading: loadingSupplementBulkImports } = useAsyncData(() => {
    const data = {
      data: {
        policy_period_id: currentPolicyPeriod?.id,
      },
    }
    return supplementBulkImportCollection.fetch(data)
  }, [])

  const onClose = () => {
    supplementDispatch({
      type: UPDATE_DATA,
      payload: {
        showManageImportedModal: false,
      },
    })
  }

  if (loadingSupplementBulkImports) {
    return <PageLoading />
  }

  return (
    <Modal
      title={i18n.t('payroll_bundle.manage_imported_supplements.title')}
      description={i18n.t('payroll_bundle.manage_imported_supplements.description', {
        payroll_period: currentPolicyPeriod?.attributes.name,
      })}
      onClose={onClose}
    >
      <SupplementsList />
    </Modal>
  )
}

export default observer(ManageImportedModal)
